(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AssignServiceFee', AssignServiceFee);

    AssignServiceFee.$inject = ['$resource'];

    function AssignServiceFee ($resource) {
        var resourceUrl =  'api/assign-service-fees/:id/:projectid/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
